export default "<p>confirm-order works!</p>\n"